import { Record, type RecordOf } from 'immutable';
import z from 'zod';
import { getLogger } from '../../utils/core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
const log = getLogger('tagTypes.js');

export const TAGS_REDUCER_KEY = 'tagStore';

export const TagSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    isDeleted: z.boolean(),
    description: z.string(),
    type: z.string(),
    copyNumber: z.string(),
    isHidden: z.boolean(),
    clientId: z.string(),
    createdAt: z.string(),
  })
  .partial();

export type TagProps = z.infer<typeof TagSchema>;
export type Tag = RecordOf<TagProps>;

export const mkNewTag = Record<TagProps>({
  id: undefined,
  name: undefined,
  isDeleted: undefined,
  description: undefined,
  type: undefined,
  copyNumber: undefined,
  isHidden: undefined,
  clientId: undefined,
  createdAt: undefined,
});

// protection to keep record factory from exploding with bad data passed in
export const mkTag = (tag: TagProps) => {
  if (typeof tag === 'object') {
    return mkNewTag(tag);
  }
  log.debug('No tag object provided - defaulting to empty tag record\n' + 'Data provided:', tag);
  return mkNewTag();
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TAGS_REDUCER_KEY]: QcsSyncResourceStore<TagProps>;
  }
}
